import React from 'react';
import Form from 'antd/lib/form';
import 'antd/lib/form/style/index.css';
import Select from 'antd/lib/select';
import 'antd/lib/select/style/index.css';
var ListAthleteFilterGender = function (props) { return (React.createElement(Form.Item, { label: React.createElement("strong", null, "Gender"), colon: false },
    React.createElement(Select, { size: 'large', allowClear: true, style: { display: 'block' }, onChange: function (value) {
            props.setFilters({ filterGender: value });
        } },
        React.createElement(Select.Option, { value: '' }, "- Not specified -"),
        React.createElement(Select.Option, { value: 'female' }, "Female"),
        React.createElement(Select.Option, { value: 'male' }, "Male")))); };
export default ListAthleteFilterGender;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/ListAthletePage/ListAthleteFilterGender.tsx
// module id = 1098
// module chunks = 0